// // import { useFormik } from 'formik';
// // import { useState } from 'react';
// // import { useTranslation } from 'react-i18next';
// // import { invoicesCreateAccount } from '@store/Finance/AP/ApInvoices/ApInvoicesSlice';
// // import { useAppDispatch } from '@store/hooks';
// // import CustomAlert from '@components/Shared/Alert/CustomAlert';
// // import { Card } from '@components/card/card';
// // import confirmAction from '@components/Shared/Alert/confirmAction';

// // interface Props {
// //   selectedApInvoices: any[];
// //   onClose: () => void;
// // }

// // const AddCreateAccountApInvoices = ({ selectedApInvoices, onClose }: Props) => {
// //   const { t, i18n } = useTranslation();
// //   const [responseData, setResponseData] = useState<any[]>([]);
// //   const [activeTab, setActiveTab] = useState<'summary' | 'details'>('summary');
// //   const [showResults, setShowResults] = useState(false);
// //   const [isSubmitting, setIsSubmitting] = useState(false);

// //   const dispatch = useAppDispatch();

// //   const formik = useFormik({
// //     initialValues: {},
// //     onSubmit: async () => {
// //       const ids = selectedApInvoices?.map(m => m.id);

// //       const body = {
// //         transections: ids
// //       };

// //       const confirm = await confirmAction(t('confirmPostMessage'));

// //       if (!confirm) {
// //         formik.setSubmitting(false);
// //         return;
// //       }
// //       setIsSubmitting(true);

// //       dispatch(invoicesCreateAccount(body))
// //         .unwrap()
// //         .then(res => {
// //           if (res.succeeded) {
// //             setResponseData(res.data || []);
// //             setShowResults(true);

// //             // حساب الإحصائيات بعد استلام البيانات
// //             const successCount = res.data.filter((item: any) => item.succeeded).length;
// //             const errorCount = res.data.filter((item: any) => !item.succeeded).length;

// //             // عرض رسالة تنبيه مناسبة بناءً على النتائج
// //             if (errorCount === 0) {
// //               // كل العمليات ناجحة
// //               CustomAlert({
// //                 action: 'Add',
// //                 msg: t('PostSuccessMessage'),
// //                 Timer: 10000
// //               });
// //             } else if (successCount === 0) {
// //               // كل العمليات فاشلة
// //               CustomAlert({
// //                 action: 'Error',
// //                 msg: t('AllOperationsFailed'),
// //                 Timer: 10000
// //               });
// //             } else {
// //               // بعض العمليات ناجحة والبعض الآخر فاشل
// //               CustomAlert({
// //                 action: 'Error',
// //                 msg: `${successCount} ${t('operationsSucceeded')} ${errorCount} ${t('operationsFailed')}`,
// //                 Timer: 10000
// //               });
// //             }

// //             // التمرير تلقائياً إلى قسم النتائج
// //             setTimeout(() => {
// //               const resultsSection = document.getElementById('processing-results');
// //               if (resultsSection) {
// //                 resultsSection.scrollIntoView({ behavior: 'smooth' });
// //               }
// //             }, 300);
// //           } else {
// //             CustomAlert({
// //               action: 'Error',
// //               msg: res.message || t('PostErrorMessage')
// //             });
// //           }
// //         })
// //         .catch(error => {
// //           console.error('Post error:', error);
// //           CustomAlert({
// //             action: 'Error',
// //             msg: error.message || t('PostErrorMessage')
// //           });
// //         })
// //         .finally(() => {
// //           formik.setSubmitting(false);
// //           setIsSubmitting(false);
// //         });
// //     }
// //   });
// //   // حساب الإحصائيات
// //   const successCount = responseData.filter(item => item.succeeded).length;
// //   const errorCount = responseData.filter(item => !item.succeeded).length;
// //   const totalCount = responseData.length;

// //   return (
// //     <>
// //       <div className='p-0'>
// //         <div className='d-flex justify-content-between align-items-center mb-3'>
// //           <h4 className='m-0 text-theme'>{t('ترحيل فواتير المدفوعات')}</h4>
// //           <button
// //             type='button'
// //             className='btn-close'
// //             onClick={onClose}
// //             aria-label={t('Close')}
// //             disabled={formik.isSubmitting}
// //           ></button>
// //         </div>

// //         {/* ملخص العمليات المحددة */}
// //         <div className='alert alert-info d-flex align-items-center'>
// //           <i className='fas fa-info-circle me-2 fs-5'></i>
// //           <div className='d-flex align-items-center justify-content-between w-100'>
// //             <span>{t('selectedApInvoicesCount')}</span>
// //             <span className='fw-bold fs-5 badge bg-info text-dark'>{selectedApInvoices?.length || 0}</span>
// //           </div>
// //         </div>

// //         {/* جدول العمليات المحددة مع تمييز الصفوف */}
// //         <div className='table-responsive mb-3' style={{ maxHeight: '200px', overflowY: 'auto' }}>
// //           <table className='table  table-sm table-bordered'>
// //             <thead className='bg-theme bg-opacity-10 '>
// //               <tr>
// //                 <th className='pt-2 pb-2'>{t('InvoiceNumber')}</th>
// //                 <th className='pt-2 pb-2'>{t('Supplier')}</th>
// //                 <th className='pt-2 pb-2'>{t('Date')}</th>
// //                 <th className='pt-2 pb-2'>{t('Amount')}</th>
// //                 <th className='pt-2 pb-2'>{t('الحالة')}</th>
// //               </tr>
// //             </thead>

// //             <tbody>
// //               {selectedApInvoices?.map((item, index) => (
// //                 <tr key={item.id}>
// //                   <td className='align-middle'>{item.invoiceNum}</td>
// //                   <td className='align-middle'>{i18n.language === 'en' ? item.peopleName : item.peopleName2}</td>
// //                   <td className='align-middle'>{item.invoiceDate?.toString()} </td>
// //                   <td className='align-middle'>{item.invoiceAmount}</td>
// //                   <td className='align-middle'>
// //                     <span className='badge bg-warning text-dark'>
// //                       <i className='fas fa-clock me-1'></i>
// //                       {t('Pending')}
// //                     </span>
// //                   </td>
// //                 </tr>
// //               ))}
// //             </tbody>
// //           </table>

// //           {(!selectedApInvoices || selectedApInvoices.length === 0) && (
// //             <div className='text-center py-4 text-muted'>
// //               <i className='fas fa-inbox fa-2x mb-2'></i>
// //               <p>{t('NoTransactionsSelected')}</p>
// //             </div>
// //           )}
// //         </div>

// //         {/* نتائج المعالجة */}
// //         {showResults && responseData.length > 0 && (
// //           <div id='processing-results' className='mt-4'>
// //             <div className='d-flex justify-content-between align-items-center mb-3'>
// //               <h5 className='text-theme m-0'>
// //                 <i className='fas fa-list-check me-2'></i>
// //                 {t('ProcessingResults')}
// //               </h5>

// //               {/* أزرار التبويب */}
// //               <div className='btn-group' role='group'>
// //                 <button
// //                   type='button'
// //                   className={`btn btn-sm ${activeTab === 'summary' ? 'btn-theme' : 'btn-outline-theme'}`}
// //                   onClick={() => setActiveTab('summary')}
// //                 >
// //                   <i className='fas fa-chart-pie me-1'></i>
// //                   {t('Summary')}
// //                 </button>
// //                 <button
// //                   type='button'
// //                   className={`btn btn-sm ${activeTab === 'details' ? 'btn-theme' : 'btn-outline-theme'}`}
// //                   onClick={() => setActiveTab('details')}
// //                 >
// //                   <i className='fas fa-table-list me-1'></i>
// //                   {t('Details')}
// //                 </button>
// //               </div>
// //             </div>

// //             {/* ملخص النتائج */}
// //             {activeTab === 'summary' && (
// //               <div className='row mb-4'>
// //                 <div className='col-md-4'>
// //                   <Card className=' bg-body-secondary'>
// //                     <div className='card-body text-center'>
// //                       <h3 className='card-title'>{totalCount}</h3>
// //                       <p className='card-text'>{t('TotalTransactions')}</p>
// //                     </div>
// //                   </Card>
// //                 </div>
// //                 <div className='col-md-4'>
// //                   <Card className=' bg-success bg-opacity-30 '>
// //                     <div className='card-body text-center'>
// //                       <h3 className='card-title text-success'>{successCount}</h3>
// //                       <p className='card-text'>{t('Successful')}</p>
// //                     </div>
// //                   </Card>
// //                 </div>
// //                 <div className='col-md-4'>
// //                   <Card className=' bg-danger bg-opacity-30 '>
// //                     <div className='card-body text-center'>
// //                       <h3 className='card-title text-danger'>{errorCount}</h3>
// //                       <p className='card-text'>{t('Failed')}</p>
// //                     </div>
// //                   </Card>
// //                 </div>
// //               </div>
// //             )}

// //             {/* تفاصيل النتائج */}
// //             {activeTab === 'details' && (
// //               <div className='table-responsive' style={{ maxHeight: '400px', overflowY: 'auto' }}>
// //                 <table className='table table-sm table-bordered table-hover'>
// //                   <thead className='  sticky-top'>
// //                     <tr>
// //                       <th className='pt-2 pb-2'>{t('code')}</th>
// //                       <th className='pt-2 pb-2'>{t('type')}</th>
// //                       <th className='pt-2 pb-2'>{t('status')}</th>
// //                       <th className='pt-2 pb-2'>{t('errorMessage')}</th>
// //                     </tr>
// //                   </thead>
// //                   <tbody>
// //                     {responseData.map((item, index) => (
// //                       <tr key={index} className={item.succeeded ? 'table-success' : 'table-danger'}>
// //                         <td className='align-middle fw-bold'>{item.code}</td>
// //                         <td className='align-middle'>{i18n.language === 'en' ? item.type : item.type2}</td>
// //                         <td className='align-middle'>
// //                           {item.succeeded ? (
// //                             <span className='badge bg-success'>
// //                               <i className='fas fa-check-circle me-1'></i>
// //                               {t('Success')}
// //                             </span>
// //                           ) : (
// //                             <span className='badge bg-danger'>
// //                               <i className='fas fa-exclamation-circle me-1'></i>
// //                               {t('Failed')}
// //                             </span>
// //                           )}
// //                         </td>

// //                         <td className='align-middle'>
// //                           {item.succeeded ? (
// //                             <div className='text-success small d-flex align-items-center'>
// //                               <i className='fas fa-check-circle me-1'></i>
// //                               {t('Successful')}
// //                             </div>
// //                           ) : (
// //                             <div className='text-danger small d-flex align-items-center'>
// //                               <i className='fas fa-exclamation-triangle me-1'></i>
// //                               {item.errorMessage || t('OperationFailed')}
// //                             </div>
// //                           )}
// //                         </td>
// //                       </tr>
// //                     ))}
// //                   </tbody>
// //                 </table>
// //               </div>
// //             )}
// //           </div>
// //         )}

// //         {/* أزرار الإجراء */}
// //         <form onSubmit={formik.handleSubmit} className='mt-4'>
// //           <div className='row g-2'>
// //             <div className='col-md-6'>
// //               <button
// //                 type='submit'
// //                 className='btn btn-lg btn-theme w-100 rounded-1 d-flex align-items-center justify-content-center'
// //                 disabled={formik.isSubmitting || isSubmitting || selectedApInvoices?.length === 0}
// //               >
// //                 {formik.isSubmitting || isSubmitting ? (
// //                   <>
// //                     <div className='spinner-border spinner-border-sm me-2'></div>
// //                     {t('Processing')}
// //                   </>
// //                 ) : (
// //                   <>
// //                     <i className='fas fa-paper-plane me-2'></i>
// //                     {t('Post')} {selectedApInvoices?.length > 0 && `(${selectedApInvoices.length})`}
// //                   </>
// //                 )}
// //               </button>
// //             </div>
// //             <div className='col-md-6'>
// //               <button
// //                 type='button'
// //                 className='btn btn-lg btn-outline-secondary w-100 rounded-1 d-flex align-items-center justify-content-center'
// //                 onClick={onClose}
// //                 disabled={formik.isSubmitting || isSubmitting}
// //               >
// //                 <i className='fas fa-times me-2'></i>
// //                 {t('Cancel')}
// //               </button>
// //             </div>
// //           </div>
// //         </form>
// //       </div>
// //     </>
// //   );
// // };

// // export default AddCreateAccountApInvoices;

// // import { useFormik } from 'formik';
// // import { useMemo, useState } from 'react';
// // import { useTranslation } from 'react-i18next';
// // import { invoicesCreateAccount } from '@store/Finance/AP/ApInvoices/ApInvoicesSlice';
// // import { useAppDispatch } from '@store/hooks';
// // import CustomAlert from '@components/Shared/Alert/CustomAlert';
// // import { Card } from '@components/card/card';
// // import confirmAction from '@components/Shared/Alert/confirmAction';
// // import NeatixModal from '@components/Modal/NeatixModal';
// // import JournalsByReference from '@pages/Finance/Journals/JournalsByReference/JournalsByReference';

// // interface Props {
// //   selectedApInvoices: any[];
// //   onClose: () => void;
// // }

// // const AddCreateAccountApInvoices = ({ selectedApInvoices, onClose }: Props) => {
// //   const { t, i18n } = useTranslation();
// //   const [responseData, setResponseData] = useState<any[]>([]);
// //   const [activeTab, setActiveTab] = useState<'summary' | 'details'>('summary');
// //   const [showResults, setShowResults] = useState(false);
// //   const [isSubmitting, setIsSubmitting] = useState(false);

// //   // ✅ Journal Modal State
// //   const [showJournalModal, setShowJournalModal] = useState(false);
// //   const [journalRefId, setJournalRefId] = useState<string | null>(null);

// //   const dispatch = useAppDispatch();

// //   // ✅ دالة تحاول استخراج الـ referenceId من نتيجة الـ API أو تعمل fallback على id من selectedApInvoices
// //   const resolveReferenceId = (resultItem: any) => {
// //     // الأفضل: API يرجّع واحد من هذه
// //     const direct =
// //       resultItem?.referenceId ??
// //       resultItem?.invoiceId ??
// //       resultItem?.refId ??
// //       resultItem?.id;

// //     if (direct) return String(direct);

// //     // fallback: إذا code = invoiceNum نجيب id من selectedApInvoices
// //     const matched = selectedApInvoices?.find(x => String(x.invoiceNum) === String(resultItem?.code));
// //     return matched?.id ? String(matched.id) : null;
// //   };

// //   const openJournal = (refId: string | null) => {
// //     if (!refId) return;
// //     setJournalRefId(refId);
// //     setShowJournalModal(true);
// //   };

// //   const formik = useFormik({
// //     initialValues: {},
// //     onSubmit: async () => {
// //       const ids = selectedApInvoices?.map(m => m.id);
// //       const body = { transections: ids };

// //       const confirm = await confirmAction(t('confirmPostMessage'));
// //       if (!confirm) {
// //         formik.setSubmitting(false);
// //         return;
// //       }

// //       setIsSubmitting(true);

// //       dispatch(invoicesCreateAccount(body))
// //         .unwrap()
// //         .then(res => {
// //           if (res.succeeded) {
// //             const data = res.data || [];
// //             setResponseData(data);
// //             setShowResults(true);

// //             const successCount = data.filter((item: any) => item.succeeded).length;
// //             const errorCount = data.filter((item: any) => !item.succeeded).length;

// //             if (errorCount === 0) {
// //               CustomAlert({ action: 'Add', msg: t('PostSuccessMessage'), Timer: 10000 });
// //             } else if (successCount === 0) {
// //               CustomAlert({ action: 'Error', msg: t('AllOperationsFailed'), Timer: 10000 });
// //             } else {
// //               CustomAlert({
// //                 action: 'Error',
// //                 msg: `${successCount} ${t('operationsSucceeded')} ${errorCount} ${t('operationsFailed')}`,
// //                 Timer: 10000
// //               });
// //             }

// //             setTimeout(() => {
// //               const resultsSection = document.getElementById('processing-results');
// //               if (resultsSection) resultsSection.scrollIntoView({ behavior: 'smooth' });
// //             }, 300);
// //           } else {
// //             CustomAlert({ action: 'Error', msg: res.message || t('PostErrorMessage') });
// //           }
// //         })
// //         .catch((error: any) => {
// //           console.error('Post error:', error);
// //           CustomAlert({ action: 'Error', msg: error.message || t('PostErrorMessage') });
// //         })
// //         .finally(() => {
// //           formik.setSubmitting(false);
// //           setIsSubmitting(false);
// //         });
// //     }
// //   });

// //   // ✅ إحصائيات
// //   const successCount = responseData.filter(item => item.succeeded).length;
// //   const errorCount = responseData.filter(item => !item.succeeded).length;
// //   const totalCount = responseData.length;

// //   // ✅ Map للنتائج عشان نعرض حالة كل فاتورة في جدول المحدد
// //   const resultByInvoiceNum = useMemo(() => {
// //     const map = new Map<string, any>();
// //     responseData.forEach(r => {
// //       if (r?.code != null) map.set(String(r.code), r);
// //     });
// //     return map;
// //   }, [responseData]);

// //   const getSelectedRowStatus = (inv: any) => {
// //     if (!showResults) {
// //       return (
// //         <span className='badge bg-warning text-dark'>
// //           <i className='fas fa-clock me-1'></i>
// //           {t('Pending')}
// //         </span>
// //       );
// //     }

// //     const r = resultByInvoiceNum.get(String(inv.invoiceNum));
// //     if (!r) {
// //       return (
// //         <span className='badge bg-secondary'>
// //           <i className='fas fa-question-circle me-1'></i>
// //           {t('Unknown')}
// //         </span>
// //       );
// //     }

// //     return r.succeeded ? (
// //       <span className='badge bg-success'>
// //         <i className='fas fa-check-circle me-1'></i>
// //         {t('Success')}
// //       </span>
// //     ) : (
// //       <span className='badge bg-danger'>
// //         <i className='fas fa-exclamation-circle me-1'></i>
// //         {t('Failed')}
// //       </span>
// //     );
// //   };

// //   return (
// //     <>
// //       <div className='p-0'>
// //         <div className='d-flex justify-content-between align-items-center mb-3'>
// //           <h4 className='m-0 text-theme'>{t('ترحيل فواتير المدفوعات')}</h4>
// //           <button
// //             type='button'
// //             className='btn-close'
// //             onClick={onClose}
// //             aria-label={t('Close')}
// //             disabled={formik.isSubmitting || isSubmitting}
// //           />
// //         </div>

// //         {/* ملخص العمليات المحددة */}
// //         <div className='alert alert-info d-flex align-items-center'>
// //           <i className='fas fa-info-circle me-2 fs-5'></i>
// //           <div className='d-flex align-items-center justify-content-between w-100'>
// //             <span>{t('selectedApInvoicesCount')}</span>
// //             <span className='fw-bold fs-5 badge bg-info text-dark'>{selectedApInvoices?.length || 0}</span>
// //           </div>
// //         </div>

// //         {/* جدول العمليات المحددة */}
// //         <div className='table-responsive mb-3' style={{ maxHeight: '200px', overflowY: 'auto' }}>
// //           <table className='table table-sm table-bordered'>
// //             <thead className='bg-theme bg-opacity-10'>
// //               <tr>
// //                 <th className='pt-2 pb-2'>{t('InvoiceNumber')}</th>
// //                 <th className='pt-2 pb-2'>{t('Supplier')}</th>
// //                 <th className='pt-2 pb-2'>{t('Date')}</th>
// //                 <th className='pt-2 pb-2'>{t('Amount')}</th>
// //                 <th className='pt-2 pb-2'>{t('الحالة')}</th>
// //               </tr>
// //             </thead>

// //             <tbody>
// //               {selectedApInvoices?.map((item: any) => (
// //                 <tr key={item.id}>
// //                   <td className='align-middle'>{item.invoiceNum}</td>
// //                   <td className='align-middle'>{i18n.language === 'en' ? item.peopleName : item.peopleName2}</td>
// //                   <td className='align-middle'>{item.invoiceDate?.toString()}</td>
// //                   <td className='align-middle'>{item.invoiceAmount}</td>
// //                   <td className='align-middle'>{getSelectedRowStatus(item)}</td>
// //                 </tr>
// //               ))}
// //             </tbody>
// //           </table>

// //           {(!selectedApInvoices || selectedApInvoices.length === 0) && (
// //             <div className='text-center py-4 text-muted'>
// //               <i className='fas fa-inbox fa-2x mb-2'></i>
// //               <p>{t('NoTransactionsSelected')}</p>
// //             </div>
// //           )}
// //         </div>

// //         {/* نتائج المعالجة */}
// //         {showResults && responseData.length > 0 && (
// //           <div id='processing-results' className='mt-4'>
// //             <div className='d-flex justify-content-between align-items-center mb-3'>
// //               <h5 className='text-theme m-0'>
// //                 <i className='fas fa-list-check me-2'></i>
// //                 {t('ProcessingResults')}
// //               </h5>

// //               <div className='btn-group' role='group'>
// //                 <button
// //                   type='button'
// //                   className={`btn btn-sm ${activeTab === 'summary' ? 'btn-theme' : 'btn-outline-theme'}`}
// //                   onClick={() => setActiveTab('summary')}
// //                 >
// //                   <i className='fas fa-chart-pie me-1'></i>
// //                   {t('Summary')}
// //                 </button>
// //                 <button
// //                   type='button'
// //                   className={`btn btn-sm ${activeTab === 'details' ? 'btn-theme' : 'btn-outline-theme'}`}
// //                   onClick={() => setActiveTab('details')}
// //                 >
// //                   <i className='fas fa-table-list me-1'></i>
// //                   {t('Details')}
// //                 </button>
// //               </div>
// //             </div>

// //             {activeTab === 'summary' && (
// //               <div className='row mb-4'>
// //                 <div className='col-md-4'>
// //                   <Card className='bg-body-secondary'>
// //                     <div className='card-body text-center'>
// //                       <h3 className='card-title'>{totalCount}</h3>
// //                       <p className='card-text'>{t('TotalTransactions')}</p>
// //                     </div>
// //                   </Card>
// //                 </div>
// //                 <div className='col-md-4'>
// //                   <Card className='bg-success bg-opacity-30'>
// //                     <div className='card-body text-center'>
// //                       <h3 className='card-title text-success'>{successCount}</h3>
// //                       <p className='card-text'>{t('Successful')}</p>
// //                     </div>
// //                   </Card>
// //                 </div>
// //                 <div className='col-md-4'>
// //                   <Card className='bg-danger bg-opacity-30'>
// //                     <div className='card-body text-center'>
// //                       <h3 className='card-title text-danger'>{errorCount}</h3>
// //                       <p className='card-text'>{t('Failed')}</p>
// //                     </div>
// //                   </Card>
// //                 </div>
// //               </div>
// //             )}

// //             {activeTab === 'details' && (
// //               <div className='table-responsive' style={{ maxHeight: '400px', overflowY: 'auto' }}>
// //                 <table className='table table-sm table-bordered table-hover'>
// //                   <thead className='sticky-top'>
// //                     <tr>
// //                       <th className='pt-2 pb-2'>{t('code')}</th>
// //                       <th className='pt-2 pb-2'>{t('type')}</th>
// //                       <th className='pt-2 pb-2'>{t('status')}</th>
// //                       <th className='pt-2 pb-2'>{t('errorMessage')}</th>
// //                       {/* ✅ جديد */}
// //                       <th className='pt-2 pb-2 text-center'>{t('عرض القيد')}</th>
// //                     </tr>
// //                   </thead>
// //                   <tbody>
// //                     {responseData.map((item: any, index: number) => {
// //                       const refId = resolveReferenceId(item);

// //                       return (
// //                         <tr key={index} className={item.succeeded ? 'table-success' : 'table-danger'}>
// //                           <td className='align-middle fw-bold'>{item.code}</td>
// //                           <td className='align-middle'>{i18n.language === 'en' ? item.type : item.type2}</td>
// //                           <td className='align-middle'>
// //                             {item.succeeded ? (
// //                               <span className='badge bg-success'>
// //                                 <i className='fas fa-check-circle me-1'></i>
// //                                 {t('Success')}
// //                               </span>
// //                             ) : (
// //                               <span className='badge bg-danger'>
// //                                 <i className='fas fa-exclamation-circle me-1'></i>
// //                                 {t('Failed')}
// //                               </span>
// //                             )}
// //                           </td>

// //                           <td className='align-middle'>
// //                             {item.succeeded ? (
// //                               <div className='text-success small d-flex align-items-center'>
// //                                 <i className='fas fa-check-circle me-1'></i>
// //                                 {t('Successful')}
// //                               </div>
// //                             ) : (
// //                               <div className='text-danger small d-flex align-items-center'>
// //                                 <i className='fas fa-exclamation-triangle me-1'></i>
// //                                 {item.errorMessage || t('OperationFailed')}
// //                               </div>
// //                             )}
// //                           </td>

// //                           {/* ✅ زر عرض القيد */}
// //                           <td className='align-middle text-center'>
// //                             {item.succeeded ? (
// //                               <button
// //                                 type='button'
// //                                 className='btn btn-sm btn-outline-primary'
// //                                 onClick={() => openJournal(refId)}
// //                                 disabled={!refId}
// //                                 title={refId ? '' : t('NoReferenceIdReturned')}
// //                               >
// //                                 <i className='fas fa-book me-1'></i>
// //                                 {t('عرض القيد')}
// //                               </button>
// //                             ) : (
// //                               <span className='text-muted small'>-</span>
// //                             )}
// //                           </td>
// //                         </tr>
// //                       );
// //                     })}
// //                   </tbody>
// //                 </table>
// //               </div>
// //             )}
// //           </div>
// //         )}

// //         {/* أزرار الإجراء */}
// //         <form onSubmit={formik.handleSubmit} className='mt-4'>
// //           <div className='row g-2'>
// //             <div className='col-md-6'>
// //               <button
// //                 type='submit'
// //                 className='btn btn-lg btn-theme w-100 rounded-1 d-flex align-items-center justify-content-center'
// //                 disabled={formik.isSubmitting || isSubmitting || selectedApInvoices?.length === 0}
// //               >
// //                 {formik.isSubmitting || isSubmitting ? (
// //                   <>
// //                     <div className='spinner-border spinner-border-sm me-2'></div>
// //                     {t('Processing')}
// //                   </>
// //                 ) : (
// //                   <>
// //                     <i className='fas fa-paper-plane me-2'></i>
// //                     {t('Post')} {selectedApInvoices?.length > 0 && `(${selectedApInvoices.length})`}
// //                   </>
// //                 )}
// //               </button>
// //             </div>
// //             <div className='col-md-6'>
// //               <button
// //                 type='button'
// //                 className='btn btn-lg btn-outline-secondary w-100 rounded-1 d-flex align-items-center justify-content-center'
// //                 onClick={onClose}
// //                 disabled={formik.isSubmitting || isSubmitting}
// //               >
// //                 <i className='fas fa-times me-2'></i>
// //                 {t('Cancel')}
// //               </button>
// //             </div>
// //           </div>
// //         </form>
// //       </div>

// //       {/* ✅ Modal عرض القيد */}
// //       <NeatixModal show={showJournalModal} setShow={setShowJournalModal} size='xl' showHeader={true}>
// //         <div className='p-2'>
// //           <div className='d-flex align-items-center justify-content-between mb-2'>
// //             <h5 className='m-0 text-theme'>
// //               <i className='fas fa-book me-2'></i>
// //               {t('عرض القيد')}
// //             </h5>
// //             <button type='button' className='btn-close' onClick={() => setShowJournalModal(false)} aria-label='Close' />
// //           </div>

// //           {journalRefId && <JournalsByReference referenceId={journalRefId} />}
// //         </div>
// //       </NeatixModal>
// //     </>
// //   );
// // };

// // export default AddCreateAccountApInvoices;

// import { useFormik } from 'formik';
// import { useMemo, useState, useEffect } from 'react';
// import { useTranslation } from 'react-i18next';
// import { invoicesCreateAccount } from '@store/Finance/AP/ApInvoices/ApInvoicesSlice';
// import { useAppDispatch } from '@store/hooks';
// import CustomAlert from '@components/Shared/Alert/CustomAlert';
// import { Card, CardBody, CardHeader, CardFooter } from '@components/card/card';
// import confirmAction from '@components/Shared/Alert/confirmAction';
// import NeatixModal from '@components/Modal/NeatixModal';
// import JournalsByReference from '@pages/Finance/Journals/JournalsByReference/JournalsByReference';

// interface Props {
//   selectedApInvoices: any[];
//   onClose: () => void;
// }

// const AddCreateAccountApInvoices = ({ selectedApInvoices, onClose }: Props) => {
//   const { t, i18n } = useTranslation();
//   const [responseData, setResponseData] = useState<any[]>([]);
//   const [activeTab, setActiveTab] = useState<'summary' | 'details'>('summary');
//   const [showResults, setShowResults] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [showAllDetails, setShowAllDetails] = useState(false);

//   // ✅ Journal Modal State
//   const [showJournalModal, setShowJournalModal] = useState(false);
//   const [journalRefId, setJournalRefId] = useState<string | null>(null);

//   const dispatch = useAppDispatch();

//   // ✅ Auto-scroll to results when showResults changes
//   useEffect(() => {
//     if (showResults) {
//       setTimeout(() => {
//         const resultsSection = document.getElementById('processing-results');
//         if (resultsSection) {
//           resultsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
//         }
//       }, 100);
//     }
//   }, [showResults]);

//   // ✅ دالة تحاول استخراج الـ referenceId من نتيجة الـ API أو تعمل fallback على id من selectedApInvoices
//   const resolveReferenceId = (resultItem: any) => {
//     const direct = resultItem?.referenceId ?? resultItem?.invoiceId ?? resultItem?.refId ?? resultItem?.id;

//     if (direct) return String(direct);

//     // fallback: إذا code = invoiceNum نجيب id من selectedApInvoices
//     const matched = selectedApInvoices?.find(x => String(x.invoiceNum) === String(resultItem?.code));
//     return matched?.id ? String(matched.id) : null;
//   };

//   const openJournal = (refId: string | null) => {
//     if (!refId) return;
//     setJournalRefId(refId);
//     setShowJournalModal(true);
//   };

//   const formik = useFormik({
//     initialValues: {},
//     onSubmit: async () => {
//       const ids = selectedApInvoices?.map(m => m.id);
//       const body = { transections: ids };

//       const confirm = await confirmAction(
//         t('confirmPostMessage'),
//         t('PostConfirmTitle'),
//         'question',
//         t('confirm'),
//         t('cancel')
//       );
//       if (!confirm) {
//         return;
//       }

//       setIsSubmitting(true);
//       setShowResults(false);
//       setResponseData([]);

//       dispatch(invoicesCreateAccount(body))
//         .unwrap()
//         .then(res => {
//           if (res.succeeded) {
//             const data = res.data || [];
//             setResponseData(data);
//             setShowResults(true);

//             const successCount = data.filter((item: any) => item.succeeded).length;
//             const errorCount = data.filter((item: any) => !item.succeeded).length;
//             const totalCount = data.length;

//             if (errorCount === 0) {
//               CustomAlert({
//                 action: 'success',
//                 msg: t('PostSuccessMessage'),
//                 Timer: 5000,
//                 title: t('Success')
//               });
//             } else if (successCount === 0) {
//               CustomAlert({
//                 action: 'error',
//                 msg: t('AllOperationsFailed'),
//                 Timer: 10000,
//                 title: t('Error')
//               });
//             } else {
//               CustomAlert({
//                 action: 'warning',
//                 msg: `${successCount}/${totalCount} ${t('operationsSucceeded')}`,
//                 Timer: 8000,
//                 title: t('PartialSuccess')
//               });
//             }
//           } else {
//             CustomAlert({
//               action: 'error',
//               msg: res.message || t('PostErrorMessage'),
//               title: t('Error')
//             });
//           }
//         })
//         .catch((error: any) => {
//           console.error('Post error:', error);
//           CustomAlert({
//             action: 'error',
//             msg: error.message || t('PostErrorMessage'),
//             title: t('Error')
//           });
//         })
//         .finally(() => {
//           formik.setSubmitting(false);
//           setIsSubmitting(false);
//         });
//     }
//   });

//   // ✅ إحصائيات
//   const successCount = responseData.filter(item => item.succeeded).length;
//   const errorCount = responseData.filter(item => !item.succeeded).length;
//   const totalCount = responseData.length;
//   const successRate = totalCount > 0 ? Math.round((successCount / totalCount) * 100) : 0;

//   // ✅ Map للنتائج عشان نعرض حالة كل فاتورة في جدول المحدد
//   const resultByInvoiceNum = useMemo(() => {
//     const map = new Map<string, any>();
//     responseData.forEach(r => {
//       if (r?.code != null) map.set(String(r.code), r);
//     });
//     return map;
//   }, [responseData]);

//   const getStatusBadge = (inv: any) => {
//     if (!showResults) {
//       return (
//         <span className='badge bg-warning bg-opacity-20 text-warning border border-warning border-opacity-50'>
//           <i className='fas fa-clock me-1'></i>
//           {t('Pending')}
//         </span>
//       );
//     }

//     const r = resultByInvoiceNum.get(String(inv.invoiceNum));
//     if (!r) {
//       return (
//         <span className='badge bg-secondary bg-opacity-20 text-secondary'>
//           <i className='fas fa-question-circle me-1'></i>
//           {t('Unknown')}
//         </span>
//       );
//     }

//     return r.succeeded ? (
//       <span className='badge bg-success bg-opacity-20 text-success border border-success border-opacity-50'>
//         <i className='fas fa-check-circle me-1'></i>
//         {t('Success')}
//       </span>
//     ) : (
//       <span className='badge bg-danger bg-opacity-20 text-danger border border-danger border-opacity-50'>
//         <i className='fas fa-exclamation-circle me-1'></i>
//         {t('Failed')}
//       </span>
//     );
//   };

//   const displayedDetails = showAllDetails ? responseData : responseData.slice(0, 5);

//   return (
//     <>
//       <div className='p-0'>
//         {/* رأس الصفحة */}
//         <div className='d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom'>
//           <div>
//             <h4 className='m-0 text-theme fw-bold'>
//               <i className='fas fa-file-invoice-dollar me-2'></i>
//               {t('ترحيل فواتير المدفوعات')}
//             </h4>
//             <p className='text-muted small mb-0 mt-1'>{t('PostingMultipleInvoices')}</p>
//           </div>
//           <button
//             type='button'
//             className='btn btn-outline-secondary btn-sm'
//             onClick={onClose}
//             disabled={formik.isSubmitting || isSubmitting}
//           >
//             <i className='fas fa-times me-1'></i>
//             {t('Close')}
//           </button>
//         </div>

//         {/* بطاقات الإحصائيات */}
//         <div className='row mb-4'>
//           {/* الفواتير المحددة */}
//           <div className='col-md-4'>
//             <Card className='bg-primary bg-opacity-10 border-primary border-0 shadow-sm'>
//               <CardBody className='text-center py-4'>
//                 <i className='fas fa-file-invoice fa-2x text-primary mb-3'></i>
//                 <h3 className='text-primary mb-1'>{selectedApInvoices?.length || 0}</h3>
//                 <p className='text-muted mb-0'>الفواتير المحددة</p>
//               </CardBody>
//             </Card>
//           </div>

//           {/* جاهزة للمعالجة */}
//           <div className='col-md-4'>
//             <Card className='bg-success bg-opacity-10 border-success border-0 shadow-sm'>
//               <CardBody className='text-center py-4'>
//                 <i className='fas fa-check-circle fa-2x text-success mb-3'></i>
//                 <h3 className='text-success mb-1'>{selectedApInvoices?.length || 0}</h3>
//                 <p className='text-muted mb-0'>جاهزة للمعالجة</p>
//               </CardBody>
//             </Card>
//           </div>

//           {/* الحالة */}
//           <div className='col-md-4'>
//             <Card className='bg-info bg-opacity-10 border-info border-0 shadow-sm'>
//               <CardBody className='text-center py-4'>
//                 <i className='fas fa-hourglass-half fa-2x text-info mb-3'></i>
//                 <h3 className='text-info mb-1'>قيد الانتظار</h3>
//                 <p className='text-muted mb-0'>حالة العملية</p>
//               </CardBody>
//             </Card>
//           </div>
//         </div>

//         {/* الفواتير المحددة */}
//         <Card className='mb-4 border-0 shadow-sm'>
//           <CardHeader className='d-flex justify-content-between align-items-center bg-transparent border-0'>
//             <h5 className='mb-0'>
//               <i className='fas fa-list-check me-2 text-theme'></i>
//               الفواتير المحددة
//               <span className='badge bg-primary ms-2'>{selectedApInvoices?.length || 0}</span>
//             </h5>
//             <div>
//               <span className='badge bg-theme me-2'>إجمالي المحدد: {selectedApInvoices?.length || 0}</span>
//             </div>
//           </CardHeader>

//           <CardBody className='p-0'>
//             <div className='table-responsive' style={{ maxHeight: '300px' }}>
//               <table className='table table-hover mb-0'>
//                 <thead className='table-active fw-bold'>
//                   <tr>
//                     <th className='text-center small'>رقم الفاتورة</th>
//                     <th className='text-center small'>المورد</th>
//                     <th className='text-center small'>التاريخ</th>
//                     <th className='text-center small'>النوع</th>
//                     <th className='text-center small'>الحالة</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {selectedApInvoices?.map((item: any) => (
//                     <tr key={item.id}>
//                       <td className='text-center align-middle'>
//                         <strong className='text-theme'>{item.invoiceNum}</strong>
//                       </td>
//                       <td className='align-middle'>
//                         <div className='d-flex flex-column'>
//                           <strong>{i18n.language === 'en' ? item.peopleName : item.peopleName2}</strong>
//                           {item.peopleCode && (
//                             <small className='text-muted'>
//                               {t('Code')}: {item.peopleCode}
//                             </small>
//                           )}
//                         </div>
//                       </td>
//                       <td className='text-center align-middle'>
//                         <strong>{item.invoiceDate?.toString()}</strong>
//                       </td>
//                       <td className='text-center align-middle'>
//                         <span className='badge bg-info'>{item.invoiceType || t('Standard')}</span>
//                       </td>
//                       <td className='text-center align-middle'>{getStatusBadge(item)}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>

//               {(!selectedApInvoices || selectedApInvoices.length === 0) && (
//                 <tr>
//                   <td colSpan={5} className='text-center py-4 text-muted'>
//                     <i className='fa fa-inbox fa-2x mb-2'></i>
//                     <br />
//                     {t('NoTransactionsSelected')}
//                   </td>
//                 </tr>
//               )}
//             </div>
//           </CardBody>

//           <CardFooter className='d-flex justify-content-between align-items-center bg-transparent'>
//             <div className='text-muted small'>
//               عرض {selectedApInvoices?.length || 0} من {selectedApInvoices?.length || 0} فاتورة
//             </div>
//             <div className='text-theme fw-bold'>
//               <i className='fas fa-info-circle me-1'></i>
//               جاهزة للمعالجة
//             </div>
//           </CardFooter>
//         </Card>

//         {/* نتائج المعالجة */}
//         {showResults && responseData.length > 0 && (
//           <div id='processing-results' className='mt-4'>
//             <Card className='border-0 shadow-sm'>
//               <CardHeader className='bg-transparent border-0'>
//                 <div className='d-flex justify-content-between align-items-center'>
//                   <div>
//                     <h5 className='m-0 text-theme'>
//                       <i className='fas fa-chart-bar me-2'></i>
//                       {t('ProcessingResults')}
//                     </h5>
//                     <p className='text-muted small mb-0 mt-1'>{t('ResultsSummary')}</p>
//                   </div>

//                   <div className='btn-group btn-group-sm' role='group'>
//                     <button
//                       type='button'
//                       className={`btn ${activeTab === 'summary' ? 'btn-theme' : 'btn-outline-theme'}`}
//                       onClick={() => setActiveTab('summary')}
//                     >
//                       <i className='fas fa-chart-pie me-1'></i>
//                       {t('Summary')}
//                     </button>
//                     <button
//                       type='button'
//                       className={`btn ${activeTab === 'details' ? 'btn-theme' : 'btn-outline-theme'}`}
//                       onClick={() => setActiveTab('details')}
//                     >
//                       <i className='fas fa-list me-1'></i>
//                       {t('Details')}
//                     </button>
//                   </div>
//                 </div>
//               </CardHeader>

//               <CardBody>
//                 {activeTab === 'summary' ? (
//                   <>
//                     {/* بطاقات إحصائيات النتائج */}
//                     <div className='row mb-4'>
//                       {/* إجمالي المعالجة */}
//                       <div className='col-md-4'>
//                         <Card className='bg-primary bg-opacity-10 border-primary border-0 shadow-sm'>
//                           <CardBody className='text-center py-4'>
//                             <i className='fas fa-cogs fa-2x text-primary mb-3'></i>
//                             <h3 className='text-primary mb-1'>{totalCount}</h3>
//                             <p className='text-muted mb-0'>إجمالي المعالجة</p>
//                           </CardBody>
//                         </Card>
//                       </div>

//                       {/* ناجحة */}
//                       <div className='col-md-4'>
//                         <Card className='bg-success bg-opacity-10 border-success border-0 shadow-sm'>
//                           <CardBody className='text-center py-4'>
//                             <i className='fas fa-check-circle fa-2x text-success mb-3'></i>
//                             <h3 className='text-success mb-1'>{successCount}</h3>
//                             <p className='text-muted mb-0'>عمليات ناجحة</p>
//                           </CardBody>
//                         </Card>
//                       </div>

//                       {/* فاشلة */}
//                       <div className='col-md-4'>
//                         <Card className='bg-danger bg-opacity-10 border-danger border-0 shadow-sm'>
//                           <CardBody className='text-center py-4'>
//                             <i className='fas fa-times-circle fa-2x text-danger mb-3'></i>
//                             <h3 className='text-danger mb-1'>{errorCount}</h3>
//                             <p className='text-muted mb-0'>عمليات فاشلة</p>
//                           </CardBody>
//                         </Card>
//                       </div>
//                     </div>
//                   </>
//                 ) : (
//                   <>
//                     <div className='table-responsive' style={{ maxHeight: '400px' }}>
//                       <table className='table table-hover mb-0'>
//                         <thead className='table-active fw-bold'>
//                           <tr>
//                             <th className='text-center small'>الفاتورة</th>
//                             <th className='text-center small'>النوع</th>
//                             <th className='text-center small'>الحالة</th>
//                             <th className='text-center small'>الرسالة</th>
//                             <th className='text-center small'>الإجراءات</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {displayedDetails.map((item: any, index: number) => {
//                             const refId = resolveReferenceId(item);
//                             return (
//                               <tr key={index} className={item.succeeded ? 'table-success' : 'table-danger'}>
//                                 <td className='text-center align-middle'>
//                                   <strong>{item.code}</strong>
//                                 </td>
//                                 <td className='text-center align-middle'>
//                                   <span className='badge bg-info'>
//                                     {i18n.language === 'en' ? item.type : item.type2}
//                                   </span>
//                                 </td>
//                                 <td className='text-center align-middle'>
//                                   {item.succeeded ? (
//                                     <span className='badge bg-success'>
//                                       <i className='fas fa-check-circle me-1'></i>
//                                       {t('Success')}
//                                     </span>
//                                   ) : (
//                                     <span className='badge bg-danger'>
//                                       <i className='fas fa-exclamation-circle me-1'></i>
//                                       {t('Failed')}
//                                     </span>
//                                   )}
//                                 </td>
//                                 <td className='align-middle'>
//                                   <div className={`small ${item.succeeded ? 'text-success' : 'text-danger'}`}>
//                                     <i
//                                       className={`fas fa-${item.succeeded ? 'check-circle' : 'exclamation-triangle'} me-1`}
//                                     ></i>
//                                     {item.succeeded ? t('Successful') : item.errorMessage || t('OperationFailed')}
//                                   </div>
//                                 </td>
//                                 <td className='text-center align-middle'>
//                                   {item.succeeded && refId ? (
//                                     <button
//                                       type='button'
//                                       className='btn btn-sm btn-outline-primary'
//                                       onClick={() => openJournal(refId)}
//                                       title={t('ViewJournalEntry')}
//                                     >
//                                       <i className='fas fa-eye me-1'></i>
//                                       {t('عرض القيد')}
//                                     </button>
//                                   ) : (
//                                     <span className='text-muted small'>-</span>
//                                   )}
//                                 </td>
//                               </tr>
//                             );
//                           })}
//                         </tbody>
//                       </table>

//                       {responseData.length > 5 && (
//                         <div className='text-center py-3 border-top'>
//                           <button
//                             type='button'
//                             className='btn btn-link text-decoration-none'
//                             onClick={() => setShowAllDetails(!showAllDetails)}
//                           >
//                             <i className={`fas fa-chevron-${showAllDetails ? 'up' : 'down'} me-1`}></i>
//                             {showAllDetails ? t('ShowLess') : t('ShowAllResults', { count: responseData.length })}
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                   </>
//                 )}
//               </CardBody>
//             </Card>
//           </div>
//         )}

//         {/* أزرار الإجراء */}
//         <form onSubmit={formik.handleSubmit} className='mt-4'>
//           <div className='row g-3'>
//             <div className='col-md-6'>
//               <button
//                 type='submit'
//                 className='btn btn-theme w-100 py-3 d-flex align-items-center justify-content-center'
//                 disabled={formik.isSubmitting || isSubmitting || selectedApInvoices?.length === 0}
//               >
//                 {formik.isSubmitting || isSubmitting ? (
//                   <>
//                     <div className='spinner-border spinner-border-sm me-2'></div>
//                     {t('Processing')}...
//                   </>
//                 ) : (
//                   <>
//                     <i className='fas fa-paper-plane me-2'></i>
//                     <div className='d-flex flex-column align-items-start'>
//                       <span className='fw-bold'>{t('PostInvoices')}</span>
//                       <small className='opacity-75'>
//                         {selectedApInvoices?.length} {t('Invoices')}
//                       </small>
//                     </div>
//                   </>
//                 )}
//               </button>
//             </div>
//             <div className='col-md-6'>
//               <button
//                 type='button'
//                 className='btn btn-outline-secondary w-100 py-3 d-flex align-items-center justify-content-center'
//                 onClick={onClose}
//                 disabled={formik.isSubmitting || isSubmitting}
//               >
//                 <i className='fas fa-times me-2'></i>
//                 <span className='fw-bold'>{t('Cancel')}</span>
//               </button>
//             </div>
//           </div>
//         </form>
//       </div>

//       {/* ✅ Modal عرض القيد */}
//       <NeatixModal show={showJournalModal} setShow={setShowJournalModal} size='xl' showHeader={true}>
//         <div className='p-3'>
//           <div className='d-flex align-items-center justify-content-between mb-3'>
//             <div>
//               <h5 className='m-0 text-theme'>
//                 <i className='fas fa-book me-2'></i>
//                 {t('عرض القيد')}
//               </h5>
//               <p className='text-muted small mb-0 mt-1'>{t('ViewingJournalForInvoice')}</p>
//             </div>
//             <button
//               type='button'
//               className='btn btn-outline-secondary btn-sm'
//               onClick={() => setShowJournalModal(false)}
//             >
//               <i className='fas fa-times me-1'></i>
//               {t('Close')}
//             </button>
//           </div>

//           {journalRefId && <JournalsByReference referenceId={journalRefId} />}
//         </div>
//       </NeatixModal>
//     </>
//   );
// };

// export default AddCreateAccountApInvoices;

import { useFormik } from 'formik';
import { useMemo, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { invoicesCreateAccount } from '@store/Finance/AP/ApInvoices/ApInvoicesSlice';
import { useAppDispatch } from '@store/hooks';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import { Card, CardBody, CardHeader, CardFooter } from '@components/card/card';
import confirmAction from '@components/Shared/Alert/confirmAction';
import NeatixModal from '@components/Modal/NeatixModal';
import JournalsByReference from '@pages/Finance/Journals/JournalsByReference/JournalsByReference';

interface Props {
  selectedApInvoices: any[];
  onClose: () => void;
}

const AddCreateAccountApInvoices = ({ selectedApInvoices, onClose }: Props) => {
  const { t, i18n } = useTranslation();
  const [responseData, setResponseData] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useState<'summary' | 'details'>('summary');
  const [showResults, setShowResults] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showAllDetails, setShowAllDetails] = useState(false);

  // ✅ Journal Modal State
  const [showJournalModal, setShowJournalModal] = useState(false);
  const [journalRefId, setJournalRefId] = useState<string | null>(null);

  const dispatch = useAppDispatch();

  // ✅ Auto-scroll to results when showResults changes
  useEffect(() => {
    if (showResults) {
      setTimeout(() => {
        const resultsSection = document.getElementById('processing-results');
        if (resultsSection) {
          resultsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  }, [showResults]);

  // ✅ دالة تحاول استخراج الـ referenceId من نتيجة الـ API أو تعمل fallback على id من selectedApInvoices
  const resolveReferenceId = (resultItem: any) => {
    const direct = resultItem?.referenceId ?? resultItem?.invoiceId ?? resultItem?.refId ?? resultItem?.id;

    if (direct) return String(direct);

    // fallback: إذا code = invoiceNum نجيب id من selectedApInvoices
    const matched = selectedApInvoices?.find(x => String(x.invoiceNum) === String(resultItem?.code));
    return matched?.id ? String(matched.id) : null;
  };

  const openJournal = (refId: string | null) => {
    if (!refId) return;
    setJournalRefId(refId);
    setShowJournalModal(true);
  };

  const formik = useFormik({
    initialValues: {},
    onSubmit: async () => {
      const ids = selectedApInvoices?.map(m => m.id);
      const body = { transections: ids };

      const confirm = await confirmAction(t('confirmPostMessage'));
      if (!confirm) {
        return;
      }

      setIsSubmitting(true);
      setShowResults(false);
      setResponseData([]);

      dispatch(invoicesCreateAccount(body))
        .unwrap()
        .then(res => {
          if (res.succeeded) {
            const data = res.data || [];
            setResponseData(data);
            setShowResults(true);

            const successCount = data.filter((item: any) => item.succeeded).length;
            const errorCount = data.filter((item: any) => !item.succeeded).length;
            const totalCount = data.length;

            if (errorCount === 0) {
              CustomAlert({
                action: 'Add',
                msg: t('PostSuccessMessage'),
                Timer: 5000
              });
            } else if (successCount === 0) {
              CustomAlert({
                action: 'Error',
                msg: t('AllOperationsFailed'),
                Timer: 10000
              });
            } else {
              CustomAlert({
                action: 'Error',
                msg: `${successCount}/${totalCount} ${t('operationsSucceeded')}`,
                Timer: 8000
                // title: t('PartialSuccess')
              });
            }
          } else {
            CustomAlert({
              action: 'Add',
              msg: res.message || t('PostErrorMessage')
            });
          }
        })
        .catch((error: any) => {
          console.error('Post error:', error);
          CustomAlert({
            action: 'Error',
            msg: error.message || t('PostErrorMessage')
            // title: t('Error')
          });
        })
        .finally(() => {
          formik.setSubmitting(false);
          setIsSubmitting(false);
        });
    }
  });

  // ✅ إحصائيات
  const successCount = responseData.filter(item => item.succeeded).length;
  const errorCount = responseData.filter(item => !item.succeeded).length;
  const totalCount = responseData.length;

  // ✅ Map للنتائج عشان نعرض حالة كل فاتورة في جدول المحدد
  const resultByInvoiceNum = useMemo(() => {
    const map = new Map<string, any>();
    responseData.forEach(r => {
      if (r?.code != null) map.set(String(r.code), r);
    });
    return map;
  }, [responseData]);

  const getStatusBadge = (inv: any) => {
    if (!showResults) {
      return (
        <span className='badge bg-warning bg-opacity-20 text-warning border border-warning border-opacity-50'>
          <i className='fas fa-clock me-1'></i>
          {t('Pending')}
        </span>
      );
    }

    const r = resultByInvoiceNum.get(String(inv.invoiceNum));
    if (!r) {
      return (
        <span className='badge bg-secondary bg-opacity-20 text-secondary'>
          <i className='fas fa-question-circle me-1'></i>
          {t('Unknown')}
        </span>
      );
    }

    return r.succeeded ? (
      <span className='badge bg-success bg-opacity-20 text-success border border-success border-opacity-50'>
        <i className='fas fa-check-circle me-1'></i>
        {t('Success')}
      </span>
    ) : (
      <span className='badge bg-danger bg-opacity-20 text-danger border border-danger border-opacity-50'>
        <i className='fas fa-exclamation-circle me-1'></i>
        {t('Failed')}
      </span>
    );
  };

  const getInvoiceTypeBadge = (type: string) => {
    switch (type) {
      case 'Standard':
        return (
          <span className='badge bg-primary'>
            <i className='fas fa-file-invoice me-1'></i>
            {t('Standard')}
          </span>
        );
      case 'CreditMemo':
      case 'DebitMemo':
        return (
          <span className='badge bg-warning text-dark'>
            <i className='fas fa-file-invoice-dollar me-1'></i>
            {t('DebitMemo')}
          </span>
        );
      default:
        return (
          <span className='badge bg-secondary'>
            <i className='fas fa-file me-1'></i>
            {type}
          </span>
        );
    }
  };

  const displayedDetails = showAllDetails ? responseData : responseData.slice(0, 5);

  return (
    <>
      <div className='p-0'>
        {/* رأس الصفحة */}
        <div className='d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom'>
          <div>
            <h4 className='m-0 text-theme fw-bold'>
              <i className='fas fa-file-invoice-dollar me-2'></i>
              {t('ترحيل فواتير المدفوعات')}
            </h4>
            {/* <p className='text-muted small mb-0 mt-1'>{t('PostingMultipleInvoices')}</p> */}
          </div>
          <button
            type='button'
            className='btn btn-outline-secondary btn-sm'
            onClick={onClose}
            disabled={formik.isSubmitting || isSubmitting}
          >
            <i className='fas fa-times me-1'></i>
            {t('Close')}
          </button>
        </div>

        {/* بطاقة الفواتير المحددة */}

        <div className='mb-4'>
          <Card className='bg-primary bg-opacity-10 border-primary border-0 shadow-sm'>
            <CardBody className='d-flex align-items-center p-3'>
              <i className='fas fa-file-invoice fa-2x text-primary me-3'></i>
              <div className='flex-grow-1'>
                <h4 className='text-primary mb-0'>{selectedApInvoices?.length || 0} فاتورة</h4>
                <p className='text-muted mb-0 small'>محددة للترحيل</p>
              </div>
              <span className='badge bg-success fs-6'>
                <i className='fas fa-check-circle me-1'></i>
                جاهزة
              </span>
            </CardBody>
          </Card>
        </div>

        {/* الفواتير المحددة */}
        <Card className='mb-4 border-0 shadow-sm'>
          <CardHeader className='d-flex justify-content-between align-items-center bg-transparent border-0'>
            <h5 className='mb-0'>
              <i className='fas fa-list-check me-2 text-theme'></i>
              الفواتير المحددة
              <span className='badge bg-primary ms-2'>{selectedApInvoices?.length || 0}</span>
            </h5>
            <div>
              <span className='badge bg-theme me-2'>إجمالي المحدد: {selectedApInvoices?.length || 0}</span>
            </div>
          </CardHeader>

          <CardBody className='p-0'>
            <div className='table-responsive' style={{ maxHeight: '300px' }}>
              <table className='table table-hover mb-0'>
                <thead
                  className='table-active fw-bold'
                  style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 101,
                    backdropFilter: 'blur(30px)'
                  }}
                >
                  <tr>
                    <th className='text-center small'>رقم الفاتورة</th>
                    <th className='text-center small'>المورد</th>
                    <th className='text-center small'>التاريخ</th>
                    <th className='text-center small'>النوع</th>
                    <th className='text-center small'>الحالة</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedApInvoices?.map((item: any) => (
                    <tr key={item.id}>
                      <td className='text-center align-middle'>
                        <strong className='text-theme'>{item.invoiceNum}</strong>
                      </td>
                      <td className='align-middle'>
                        <div className='d-flex flex-column'>
                          <strong>{i18n.language === 'en' ? item.peopleName : item.peopleName2}</strong>
                          {item.peopleCode && (
                            <small className='text-muted'>
                              {t('Code')}: {item.peopleCode}
                            </small>
                          )}
                        </div>
                      </td>
                      <td className='text-center align-middle'>
                        <strong>{item.invoiceDate?.toString()}</strong>
                      </td>

                      <td className='align-middle'>{getInvoiceTypeBadge(item.invoiceType)}</td>
                      <td className='text-center align-middle'>{getStatusBadge(item)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {(!selectedApInvoices || selectedApInvoices.length === 0) && (
                <tr>
                  <td colSpan={5} className='text-center py-4 text-muted'>
                    <i className='fa fa-inbox fa-2x mb-2'></i>
                    <br />
                    {t('NoTransactionsSelected')}
                  </td>
                </tr>
              )}
            </div>
          </CardBody>

          <CardFooter className='d-flex justify-content-between align-items-center bg-transparent'>
            <div className='text-muted small'>
              عرض {selectedApInvoices?.length || 0} من {selectedApInvoices?.length || 0} فاتورة
            </div>
            <div className='text-theme fw-bold'>
              <i className='fas fa-info-circle me-1'></i>
              جاهزة للمعالجة
            </div>
          </CardFooter>
        </Card>

        {/* نتائج المعالجة */}
        {showResults && responseData.length > 0 && (
          <div id='processing-results' className='mt-4'>
            <Card className='border-0 shadow-sm'>
              <CardHeader className='bg-transparent border-0'>
                <div className='d-flex justify-content-between align-items-center'>
                  <div>
                    <h5 className='m-0 text-theme'>
                      <i className='fas fa-chart-bar me-2'></i>
                      {t('ProcessingResults')}
                    </h5>
                    {/* <p className='text-muted small mb-0 mt-1'>{t('ResultsSummary')}</p> */}
                  </div>

                  <div className='btn-group btn-group-sm' role='group'>
                    <button
                      type='button'
                      className={`btn ${activeTab === 'summary' ? 'btn-theme' : 'btn-outline-theme'}`}
                      onClick={() => setActiveTab('summary')}
                    >
                      <i className='fas fa-chart-pie me-1'></i>
                      {t('Summary')}
                    </button>
                    <button
                      type='button'
                      className={`btn ${activeTab === 'details' ? 'btn-theme' : 'btn-outline-theme'}`}
                      onClick={() => setActiveTab('details')}
                    >
                      <i className='fas fa-list me-1'></i>
                      {t('Details')}
                    </button>
                  </div>
                </div>
              </CardHeader>

              <CardBody>
                {activeTab === 'summary' ? (
                  <>
                    {/* بطاقات إحصائيات النتائج */}
                    <div className='row mb-4'>
                      {/* إجمالي المعالجة */}
                      <div className='col-md-4'>
                        <Card className='bg-primary bg-opacity-10 border-primary border-0 shadow-sm'>
                          <CardBody className='text-center py-4'>
                            <i className='fas fa-cogs fa-2x text-primary mb-3'></i>
                            <h3 className='text-primary mb-1'>{totalCount}</h3>
                            <p className='text-muted mb-0'>إجمالي المعالجة</p>
                          </CardBody>
                        </Card>
                      </div>

                      {/* ناجحة */}
                      <div className='col-md-4'>
                        <Card className='bg-success bg-opacity-10 border-success border-0 shadow-sm'>
                          <CardBody className='text-center py-4'>
                            <i className='fas fa-check-circle fa-2x text-success mb-3'></i>
                            <h3 className='text-success mb-1'>{successCount}</h3>
                            <p className='text-muted mb-0'>عمليات ناجحة</p>
                          </CardBody>
                        </Card>
                      </div>

                      {/* فاشلة */}
                      <div className='col-md-4'>
                        <Card className='bg-danger bg-opacity-10 border-danger border-0 shadow-sm'>
                          <CardBody className='text-center py-4'>
                            <i className='fas fa-times-circle fa-2x text-danger mb-3'></i>
                            <h3 className='text-danger mb-1'>{errorCount}</h3>
                            <p className='text-muted mb-0'>عمليات فاشلة</p>
                          </CardBody>
                        </Card>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className='table-responsive' style={{ maxHeight: '400px' }}>
                      <table className='table table-hover mb-0'>
                        <thead className='table-active fw-bold'>
                          <tr>
                            <th className='text-center small'>الفاتورة</th>
                            <th className='text-center small'>النوع</th>
                            <th className='text-center small'>الحالة</th>
                            <th className='text-center small'>التفاصيل</th>
                            <th className='text-center small'>الإجراءات</th>
                          </tr>
                        </thead>
                        <tbody>
                          {displayedDetails.map((item: any, index: number) => {
                            const refId = resolveReferenceId(item);
                            return (
                              <tr key={index} className={item.succeeded ? 'table-success' : 'table-danger'}>
                                <td className='text-center align-middle'>
                                  <strong>{item.code}</strong>
                                </td>
                                <td className='text-center align-middle'>
                                  <span className='badge bg-info'>
                                    {i18n.language === 'en' ? item.type : item.type2}
                                  </span>
                                </td>
                                <td className='text-center align-middle'>
                                  {item.succeeded ? (
                                    <span className='badge bg-success'>
                                      <i className='fas fa-check-circle me-1'></i>
                                      {t('Success')}
                                    </span>
                                  ) : (
                                    <span className='badge bg-danger'>
                                      <i className='fas fa-exclamation-circle me-1'></i>
                                      {t('Failed')}
                                    </span>
                                  )}
                                </td>
                                <td className='align-middle'>
                                  <div className={`small ${item.succeeded ? 'text-success' : 'text-danger'}`}>
                                    <i
                                      className={`fas fa-${item.succeeded ? 'check-circle' : 'exclamation-triangle'} me-1`}
                                    ></i>
                                    {item.succeeded ? t('Successful') : item.errorMessage || t('OperationFailed')}
                                  </div>
                                </td>
                                <td className='text-center align-middle'>
                                  {item.succeeded && refId ? (
                                    <button
                                      type='button'
                                      className='btn btn-sm btn-outline-primary'
                                      onClick={() => openJournal(refId)}
                                      title={t('ViewJournalEntry')}
                                    >
                                      <i className='fas fa-eye me-1'></i>
                                      {t('عرض القيد')}
                                    </button>
                                  ) : (
                                    <span className='text-muted small'>-</span>
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>

                      {responseData.length > 5 && (
                        <div className='text-center py-3 border-top'>
                          <button
                            type='button'
                            className='btn btn-link text-decoration-none'
                            onClick={() => setShowAllDetails(!showAllDetails)}
                          >
                            <i className={`fas fa-chevron-${showAllDetails ? 'up' : 'down'} me-1`}></i>
                            {showAllDetails ? t('ShowLess') : t('ShowAllResults', { count: responseData.length })}
                          </button>
                        </div>
                      )}
                    </div>
                  </>
                )}
              </CardBody>

              {activeTab === 'details' && (
                <CardFooter className='d-flex justify-content-between align-items-center bg-transparent'>
                  <div className='text-muted small'>
                    عرض {displayedDetails.length} من {responseData.length} نتيجة
                  </div>
                  <div className='text-theme fw-bold'>
                    ناجحة: {successCount} | فاشلة: {errorCount}
                  </div>
                </CardFooter>
              )}
            </Card>
          </div>
        )}

        {/* أزرار الإجراء */}
        <form onSubmit={formik.handleSubmit} className='mt-4'>
          <div className='row g-3'>
            <div className='col-md-6'>
              <button
                type='submit'
                className='btn btn-theme w-100 py-3 d-flex align-items-center justify-content-center'
                disabled={formik.isSubmitting || isSubmitting || selectedApInvoices?.length === 0}
              >
                {formik.isSubmitting || isSubmitting ? (
                  <>
                    <div className='spinner-border spinner-border-sm me-2'></div>
                    {t('Processing')}...
                  </>
                ) : (
                  <>
                    <i className='fas fa-paper-plane me-2'></i>
                    <div className='d-flex flex-column align-items-start'>
                      <span className='fw-bold'>{t('Post')}</span>
                      {/* <small className='opacity-75'>
                        {selectedApInvoices?.length} {t('Invoices')}
                      </small> */}
                    </div>
                  </>
                )}
              </button>
            </div>
            <div className='col-md-6'>
              <button
                type='button'
                className='btn btn-outline-secondary w-100 py-3 d-flex align-items-center justify-content-center'
                onClick={onClose}
                disabled={formik.isSubmitting || isSubmitting}
              >
                <i className='fas fa-times me-2'></i>
                <span className='fw-bold'>{t('Cancel')}</span>
              </button>
            </div>
          </div>
        </form>
      </div>

      {/* ✅ Modal عرض القيد */}
      <NeatixModal show={showJournalModal} setShow={setShowJournalModal} size='xl' showHeader={false}>
        <div className='p-3'>
          <div className='d-flex align-items-center justify-content-between mb-3'>
            <div>
              <h5 className='m-0 text-theme'>
                <i className='fas fa-book me-2'></i>
                {t('عرض القيد')}
              </h5>
              {/* <p className='text-muted small mb-0 mt-1'>{t('ViewingJournalForInvoice')}</p> */}
            </div>
            <button
              type='button'
              className='btn btn-outline-secondary btn-sm'
              onClick={() => setShowJournalModal(false)}
            >
              <i className='fas fa-times me-1'></i>
              {t('Close')}
            </button>
          </div>

          {journalRefId && <JournalsByReference referenceId={journalRefId} />}
        </div>
      </NeatixModal>
    </>
  );
};

export default AddCreateAccountApInvoices;
